{
    "aboutbanner.label": "{siloName} Ruimtes zijn anders",
    "account.admin_email_notifications": "E-mailmeldingen voor beheerders",
    "account.admin_language": "Voorkeurstaal",
    "account.admin_language_no_language": "Geen taal",
    "account.admin_moderation_dash_settings": "Instellingen moderatiedashboard",
    "account.email_notifications": "E-mailmeldingen",
    "account.notification.email.moderationdecisions": "Mativeringsbeslissingen",
    "account.notification.email.replies": "Antwoorden",
    "account.title": "Account",
    "account.warnings_and_blocks": "Waarschuwingen en blokken",
    "account_delete.confirm_description": "Het verwijderen van uw profiel kan niet ongedaan worden gemaakt. Alle gegevens en activiteit die aan uw profiel is gekoppeld, kunnen tot 72 uur worden verwijderd.",
    "account_delete.confirm_heading": "Weet u zeker dat u uw profielgegevens wilt verwijderen?",
    "account_delete.description": "Indien gevraagd, wordt de discussiegeschiedenis en betrokkenheid van uw account bij enige discussie verwijderd als onderdeel van het verzoek. Deze actie kan niet ongedaan worden gemaakt.",
    "account_delete.heading": "Verwijder mijn gegevens",
    "account_request_data.heading": "Vraag mijn gegevens aan",
    "account_request_data.instructions": "Stuur een e-mail naar [privacy@newpublic.org](mailto:privacy@newpublic.org) om een ​​kopie van uw gegevens aan te vragen die aan deze discussieruimte zijn gekoppeld. Het kan tot 30 dagen duren om uw verzoek te verwerken.",
    "account_revoke_permissions.confirm_heading": "Beheerdersrechten van {identifier} intrekken?",
    "account_revoke_permissions.confirm_text": "{identifier} zal niet langer Admin-rechten hebben.",
    "account_revoke_permissions.revoke_button": "Toestemmingen intrekken",
    "action.block": "Blokkeren",
    "action.cancel": "Annuleren",
    "action.create_new_voting": "Creëer een nieuw stemmen",
    "action.delete": "Verwijderen",
    "action.edit": "Bewerking",
    "action.open_teaser_positioning": "Open teaser positionering",
    "action.pinned": "Vastgemaakt",
    "action.post": "Na",
    "action.reply_to_user": "Antwoord aan {userName}...",
    "action.report": "Rapport",
    "action.save": "Redden",
    "action.unblock": "Deblokkeren",
    "admin.category_analysis_heading": "Analyse",
    "admin.category_developer_tools_heading": "Ontwikkelaarstools",
    "admin.category_editorial_heading": "Redactioneel",
    "admin.category_moderation_heading": "Moderatie",
    "admin.category_owner_tools_heading": "Eigenaartools",
    "admin.category_starred_heading": "Met ster",
    "admin.window_title": "Admin-dashboard",
    "admin_mod_link.admin_users_description": "Beheer de permissions van de admin-gebruiker.",
    "admin_mod_link.developer_tools_label": "Developer Tools",
    "admin_mod_link.editorial_dashboard_description": "Beheer ruimtes en nog meer.",
    "admin_mod_link.editorial_dashboard_label": "Redactiedashboard",
    "admin_mod_link.moderation_dashboard_description": "Beheer discussies in het gerefactoreerde dashboard.",
    "admin_mod_link.moderation_dashboard_label": "Matiging dashboard",
    "admin_mod_link.ranking_eval_description": "Evalueer verschillende rangschikkingsalgoritmen op echte gesprekken.",
    "admin_mod_link.ranking_eval_label": "Rangschikking Evaluatie",
    "admin_mod_link.settings_description": "Beheer org-wide formaten en functies.",
    "admin_mod_link.settings_label": "Instellingen",
    "admin_mod_link.storybook_description": "Bekijk PSI-componenten in Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Voeg beheerders toe",
    "admin_users.add_new_admins_label": "Voeg nieuwe beheerders toe",
    "admin_users.adding_admins_message": "Admins toevoegen...",
    "admin_users.emails_placeholder": "E-mails van gebruikers om toe te voegen",
    "admin_users.heading": "Admin-gebruikers",
    "admin_users.loading_message": "Admins laden...",
    "admin_users.updating_roles_message": "Rollen bijwerken...",
    "admins.actions.edit": "Bewerken",
    "admins.actions.revoke": "Toestemmingen intrekken",
    "admins.actions.revoke-failed": "Het is niet gelukt om de beheerdersrechten van {userIdentity} in te trekken",
    "admins.actions.revoked": "{userIdentity} heeft geen Admin-rechten meer",
    "admins.all_admins": "Alle",
    "admins.column_actions": "Acties",
    "admins.column_name": "Naam",
    "admins.column_posts": "Berichten",
    "admins.column_roles": "Interne machtigingen",
    "admins.column_title": "Titel",
    "admins.error": "Kon de beheerders tabel niet ophalen",
    "admins.tab_label": "Personeelsprofielen",
    "admins.table.search": "Zoeken...",
    "admins.title": "Personeelsprofielen",
    "agree": "Mee eens zijn",
    "ai-helper.bullet": "👉 {tipText}",
    "ai-helper.rephrase_message": "Overweeg je bericht opnieuw te formuleren om een breder publiek te bereiken en meer betekenisvolle discussies te stimuleren.",
    "ai-helper.suggestions_title": "Suggesties",
    "ai-helper.tips_title": "Probeer deze tips te volgen:",
    "aitag.ai_moderated": "Met AI gemodereerd",
    "appError.goHome": "Ga Terug",
    "appError.page_forbidden": "Je account heeft geen toegang tot deze pagina.",
    "appError.page_not_found": "De pagina die je zoekt bestaat niet.",
    "appError.page_unauthorized": "Je hebt geen toestemming om deze pagina te bekijken.",
    "article.admin_only_error": "U moet inloggen als een beheerder om dit scherm te bekijken.",
    "article.login_button": "Inloggen",
    "article.no_teaser_error": "Geen teaser gedefinieerd",
    "article.zdf_section": "ZDF-sectie",
    "article_teaser_position.max_positions": "Maximaal 2 posities toegestaan",
    "audience_input.community_guidelines_title": "Communityrichtlijnen",
    "audience_input.composer_placeholder": "Deel uw gedachten...",
    "audience_input.your_reply_label": "Uw antwoord",
    "audience_input_template.description": "Verzamel vragen, getuigenissen en verhalen van gebruikers. Dit zorgt voor een groter bereik van betrokkenheid.",
    "audience_input_template.label": "Invoer van publiek",
    "blocklist.add_term_button": "Term toevoegen",
    "blocklist.add_terms": "Voeg termen toe - scheid meerdere termen met ;",
    "blocklist.delete_confirmation": "Moeten deze voorwaarden echt worden verwijderd? Je kunt ze later opnieuw toevoegen.",
    "blocklist.delete_terms": "Voorwaarden verwijderen",
    "blocklist.description": "Voorwaarden beheren die automatisch moeten worden gerapporteerd.",
    "blocklist.edit_term": "Term bewerken",
    "blocklist.empty_list": "De blocklist is leeg.",
    "blocklist.help_alternative_spellings_description": "U kunt beslissen of er rekening wordt gehouden met alternatieve spellingen. De volgende spellingen, nummers en speciale tekens worden ook in aanmerking genomen:",
    "blocklist.help_alternative_spellings_title": "Alternatieve spellingen:",
    "blocklist.help_case_note": "Bovenste en kleine letters worden in aanmerking genomen",
    "blocklist.help_character_replacements": "A → a  | a → A | a → @ | a → 4 | i → 1 | e → 3 | o → 0 | s → $ | s → 5 | t → 7 | b → 8 | g → 9",
    "blocklist.help_intro": "Met de blocklist kunt u termen definiëren die automatisch worden verhinderd om in community-berichten te worden gepubliceerd. U kunt zelf termen toevoegen aan deze pre-moderatie. Voeg alle voorwaarden toe die niet zonder menselijke beoordeling aan de lijst mogen worden gepubliceerd.",
    "blocklist.help_singular_term_description": "U kunt beslissen of alleen de enkelvoudige term moet worden overwogen of ook voorwaarden die de ingevoerde termijn bevatten.",
    "blocklist.help_singular_term_example": "Example: “person” (singular term) → “persons”. “persons” would also be taken into account if the “singular term” checkbox is not activated for “person”. This also applies to the string “personality”, for example.",
    "blocklist.help_singular_term_title": "Enkele term:",
    "blocklist.include_alternative_spellings": "Voeg alternatieve spellingen toe",
    "blocklist.no_results": "Er zijn geen resultaten die overeenkomen met uw zoekopdracht.",
    "blocklist.only_singular_term": "Alleen enkelvoudige term",
    "blocklist.settings_for_term": "Instellingen voor de term",
    "blocklist.single_term_added_success": "De term\"{singleTerm}\"is toegevoegd",
    "blocklist.single_term_not_deleted": "De blokkeerlijstterm kon niet worden verwijderd",
    "blocklist.singular_term_tag": "Enkelvoudige term",
    "blocklist.term_adoption_description": "Selecteer of voorwaarden precies moeten worden aangenomen zoals uw input is, of dat ze in een uitgebreide vorm moeten worden opgenomen.",
    "blocklist.term_already_in_list": "Deze term staat al in de lijst",
    "blocklist.term_required": "Er moet een term worden ingevoerd",
    "blocklist.terms_added_success": "{termsCount} Voorwaarden werden met succes toegevoegd",
    "blocklist.terms_already_in_list": "Deze term staat al in de lijst",
    "blocklist.terms_may_not_be_longer_than": "Termen mogen niet langer zijn dan 150 tekens.",
    "blocklist.terms_not_added_duplicate": "Blokkeerlijstterm bestaat al: {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Blokkeerlijstterm bestaat al: {duplicateTerms}. Blokkeerlijstterm kon niet worden toegevoegd, probeer het opnieuw: {refusedTerms}",
    "blocklist.terms_not_added_refused": "Blokkeerlijstterm kon niet worden toegevoegd, probeer het opnieuw: {refusedTerms}",
    "blocklist.terms_not_deleted": "{failedCount} van {totalCount} blokkeerlijsttermen konden niet worden verwijderd",
    "blocklist.title": "Blocklist",
    "blocklist.too_long_terms_removed": "Termen langer dan 150 tekens zijn verwijderd.",
    "button.react": "Reageren",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "uitgeschakeld",
    "button.react_button_selected": "gekozen",
    "button.reacted": "Gereageerd",
    "byline.deleted_user": "Verwijderde gebruiker",
    "byline.edited": "Bewerkt",
    "byline.post_id": "ID:",
    "channel_settings.title": "Kanaalinstellingen",
    "channels.add_channel_button": "Kanaal toevoegen",
    "channels.channels_label": "Kanalen",
    "channels.default_channel_label": "Standaardkanaal",
    "channels.delete_tooltip": "Je kunt het standaardkanaal of kanalen die in gebruik zijn niet verwijderen",
    "channels.image_preview": "Afbeeldingsvoorbeeld",
    "channels.manage_channels_heading": "Kanalen beheren",
    "channels.no_channel": "Geen kanaal",
    "channels.no_channels_available": "Geen kanalen beschikbaar",
    "channels.no_channels_available_info": "Maak en beheer kanalen in het moderatiedashboard.",
    "channels.not_channel_member_warning": "Je bent geen lid van dit kanaal, hierdoor zijn bepaalde functies uitgeschakeld!",
    "channels.select_channel": "Selecteer een kanaal",
    "channels.title": "Kanaal",
    "close_conversation.closed_message": "Dit gesprek is nu gesloten.",
    "comment.cancel_button": "Annuleren",
    "comment.confirm_leave_description": "De wijzigingen die u heeft aangebracht, worden niet opgeslagen.",
    "comment.confirm_leave_heading": "Weet je zeker dat je wilt vertrekken?",
    "comment.delete_button": "Verwijderen",
    "comment.delete_modal_heading": "Weet u zeker dat u dit bericht wilt verwijderen?",
    "comment.delete_modal_warning": "Deze actie kan niet ongedaan worden gemaakt.",
    "comment.edit_button": "Bewerking",
    "comment.post_button": "Na",
    "comment.posting": "Posten...",
    "comment.public_comment_subtitle": "Openbare opmerking",
    "comment.read_more_button": "Lees meer",
    "comment.reply_button": "Antwoord",
    "comment.report_button": "Rapport",
    "comment.show_less": "Toon minder",
    "comment.show_more_replies_plural": "Toon {count} meer antwoorden",
    "comment.show_more_reply_singular": "Toon {count} meer antwoord",
    "comment.show_original": "Toon origineel ({language})",
    "comment.show_translation": "Toon vertaling ({language})",
    "comment.update_button": "Update",
    "comment.updating": "Bijwerken...",
    "comment.your_reply_label": "Uw antwoord",
    "comment_feedback.only_visible_to_you": "Alleen zichtbaar voor u",
    "comment_slider.change_vote_button": "Update uw antwoord",
    "comment_slider.community_guidelines_title": "Communityrichtlijnen",
    "comment_slider.its_complicated": "Het is ingewikkeld",
    "comment_slider.no_with_reservations": "Nee met reserveringen",
    "comment_slider.public_response": "Openbare reactie",
    "comment_slider.recording_vote": "Stem opnames...",
    "comment_slider.response": "antwoord",
    "comment_slider.responses": "antwoorden",
    "comment_slider.share_thoughts": "Deel uw gedachten",
    "comment_slider.skip_change_vote": "Skip en verander stemmen",
    "comment_slider.skip_submit_vote": "Skip en geef stem in",
    "comment_slider.slide_to_respond": "Schuif om te reageren:",
    "comment_slider.strongly_no": "Sterk nee",
    "comment_slider.strongly_yes": "Sterk ja",
    "comment_slider.update_response": "Update uw antwoord",
    "comment_slider.yes_with_reservations": "Ja met reserveringen",
    "comment_slider.your_reply_label": "Uw antwoord",
    "comment_slider_editable_positions.heading": "Pas de opmerkingenbalk aan",
    "comment_slider_template.description": "Vraag gebruikers om op uw vraag te reageren langs een spectrum (bijvoorbeeld\"sterk nee\"naar\"sterk ja\").",
    "comment_slider_template.label": "Commentaar schuifregelaar",
    "common.access_denied": "Toegang geweigerd",
    "common.are": "Zijn",
    "common.cancel": "Annuleren",
    "common.download": "Downloaden",
    "common.is": "is",
    "common.loading": "Laden...",
    "common.select": "Selecteer",
    "community_guidelines.aria_popup_label": "{label} (pop-upvenster)",
    "community_guidelines.category_engage_respectfully": "Zich respectvol aangeven",
    "community_guidelines.category_no_disruptive_behavior": "Geen verstorend gedrag",
    "community_guidelines.category_no_harmful_content": "Geen schadelijke inhoud",
    "community_guidelines.category_support_claims": "Ondersteun uw claims",
    "community_guidelines.constructive_content_explanation": "**Opmerkingen die constructiever kunnen zijn** kunnen suggesties ontvangen over hoe ze beter kunnen aansluiten bij onze gemeenschapsnormen. Je hebt de keuze om je opmerking te herzien of door te gaan met plaatsen zoals geschreven. Opmerkingen die zonder herzieningen worden geplaatst na het ontvangen van suggesties, kunnen lager in de feed worden gerangschikt om meer constructieve bijdragen te prioriteren.",
    "community_guidelines.guidelines_intro": "Onze gemeenschapsrichtlijnen zijn:",
    "community_guidelines.harmful_content_explanation": "**Schadelijke inhoud** die onze gemeenschapsrichtlijnen schendt, wordt geblokkeerd voor plaatsing. Als die beslissing door AI is genomen, kunt u uw bericht ter beoordeling aan een menselijke moderator voorleggen.\n\n**Reacties die constructiever kunnen zijn** kunnen suggesties ontvangen over hoe ze meer in overeenstemming kunnen zijn met onze gemeenschapsnormen. U kunt ervoor kiezen om uw reactie te herzien of door te gaan met plaatsen zoals geschreven. Reacties die zonder herzieningen worden geplaatst na het ontvangen van suggesties, kunnen lager in de feed worden gerangschikt om meer constructieve bijdragen te prioriteren.",
    "community_guidelines.modal_heading": "Communityrichtlijnen en normen",
    "community_guidelines.modal_intro": "We streven ernaar om echte, respectvolle en open gesprekken in deze ruimte te inspireren. Iedereen is welkom om hun ervaringen te delen; perspectieven uit te wisselen en te debatteren; en vragen te stellen in de geest van vriendelijkheid, verbinding en nieuwsgierigheid.",
    "community_guidelines.moderation_explanation": "Deze ruimte is ontworpen voor meer doordachte gesprekken dan typische internetreacties. Ons moderatieproces helpt die standaard te handhaven terwijl het uw stem en perspectief respecteert.",
    "community_guidelines.norms_intro": "Onze gemeenschapsnormen zijn:",
    "community_guidelines.rule_avoid_derogatory_labels": "Vermijd denigrerende labels",
    "community_guidelines.rule_avoid_sarcasm": "Vermijd sarcasme en afwijzende antwoorden",
    "community_guidelines.rule_explain_constructively": "Verklaar constructief meningsverschillen",
    "community_guidelines.rule_express_civility": "Druk uw ideeën uit met beleefdheid",
    "community_guidelines.rule_focus_on_ideas": "Focus op ideeën, in plaats van karakteroordelen",
    "community_guidelines.rule_no_illegal_content": "Geen illegale inhoud",
    "community_guidelines.rule_no_offtopic": "Geen off-topic berichten",
    "community_guidelines.rule_no_spam": "Geen spam of commerciële promotie",
    "community_guidelines.rule_no_violent_content": "Geen gewelddadige inhoud of roept op tot schade",
    "community_guidelines.rule_provide_sources": "Bied bronnen voor feitelijke claims",
    "community_guidelines.rule_respect_privacy": "Respecteer de privacy van anderen, geen persoonlijke informatie delen",
    "community_guidelines.title": "Communityrichtlijnen",
    "community_guidelines.what_happens_heading": "Wat gebeurt er als uw bijdrage de gemeenschapsrichtlijnen of normen schendt?",
    "context_entry_points.From": "Van",
    "context_entry_points.joined_from": "Samengevoegd van",
    "conversation_helper.about": "Over conversatiehelper",
    "conversation_helper.analyze_conversation": "Analyseer gesprek",
    "conversation_helper.checks_performed": "- **{count} controle(s)** uitgevoerd",
    "conversation_helper.conversation_analysis": "Gesprekanalyse",
    "conversation_helper.conversation_stats": "Gesprekstatistieken",
    "conversation_helper.conversation_summary": "Samenvatting",
    "conversation_helper.current_guidance": "Huidige begeleiding",
    "conversation_helper.dashboard": "Gesprekshelperdashboard",
    "conversation_helper.disagree": "Oneens",
    "conversation_helper.explanation": "Uitleg",
    "conversation_helper.generate_new_guidance": "Nieuwe begeleiding genereren",
    "conversation_helper.generated_because": "Dit bericht is gegenereerd omdat...",
    "conversation_helper.generated_by_ai": "Deze begeleiding wordt gegenereerd door AI.",
    "conversation_helper.guidance_messages_generated": "- **{count} begeleidingsbericht(en)** gegenereerd",
    "conversation_helper.guidance_visible_to_everyone": "Dit begeleidingsboodschap is voor iedereen zichtbaar.",
    "conversation_helper.hello_everyone": "Hallo allemaal!",
    "conversation_helper.help_history": "Help geschiedenis",
    "conversation_helper.helpful": "Behulpzaam",
    "conversation_helper.last_analysis_none": "- Laatste gespreksanalyse:**Geen**",
    "conversation_helper.last_analysis_time": "- Laatste gespreksanalyse:**{time}**",
    "conversation_helper.new_comments_since_analysis": "-**{count} Nieuwe commentaar (s)**Sinds de laatste gespreksanalyse",
    "conversation_helper.no_history": "Geen geschiedenis beschikbaar.",
    "conversation_helper.no_problems": "Geen problemen gedetecteerd.",
    "conversation_helper.open_admin_dashboard": "Open admin-dashboard",
    "conversation_helper.problems_detected": "Problemen gedetecteerd!",
    "conversation_helper.related_space": "Gerelateerde thread",
    "conversation_helper.result": "Resultaat:",
    "conversation_helper.thank_you": "Bedankt",
    "conversation_home.about_heading": "Over {brandName}",
    "conversation_home.brand_name": "de Publieke Ruimtes Incubator",
    "conversation_home.citizen_conversation": "Neem deel aan een echt gesprek",
    "conversation_home.citizen_conversation_description": "Deel jouw perspectief in een ruimte die is ontworpen voor doordachte, constructieve dialoog.",
    "conversation_home.error_loading": "Fout bij het laden van gesprekken.",
    "conversation_home.focused_topics": "Duik in de onderwerpen die jou raken",
    "conversation_home.focused_topics_description": "Gesprekken beginnen met een duidelijke prompt of vraag, waardoor de discussie gefocust en betekenisvol blijft.",
    "conversation_home.hero_subtitle": "Doe mee aan de discussie met onze journalisten en mensen uit het hele land.",
    "conversation_home.hero_title": "Doordachte gesprekken over onderwerpen die voor jou belangrijk zijn",
    "conversation_home.latest_title": "Ontdek de nieuwste gesprekken",
    "conversation_home.no_conversations": "Nog geen gesprekken.",
    "conversation_home.with_experts": "Maak direct verbinding met experts en journalisten",
    "conversation_home.with_experts_description": "Stel vragen, krijg diepere inzichten en ga direct in gesprek met geloofwaardige stemmen die je waardeert.",
    "conversationhelper.ai.hint": "Om een ​​gastvrije en respectvolle sfeer te behouden, gebruiken we ook AI om matiging te ondersteunen. In dit gesprek geeft een AI hints voor een meer constructieve gespreksatmosfeer en vat het gesprek samen.",
    "cta_button.loading": "Laden",
    "dashboard.table.demo.pagination": "Ruimtes (Paginagewijs)",
    "dashboard.table.demo.users": "Draden",
    "date.days_abbrev": "{days}d",
    "date.hours_abbrev": "{hours}h",
    "date.minutes_abbrev": "{minutes}m",
    "date.months_abbrev": "{months}mo",
    "date.now": "nu",
    "date.years_abbrev": "{years}y",
    "deleted_post.author_deleted": "De auteur heeft dit bericht verwijderd.",
    "deleted_post.deleting": "Verwijderen…",
    "deleted_post.you_deleted": "Je hebt dit bericht verwijderd.",
    "demo.comment": "opmerking",
    "demo.comments": "opmerkingen",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "Oneens",
    "demo.fwrd": "FWRD",
    "demo.load_video_element": "Laad video-element",
    "demo.new_to_me": "Nieuw voor mij",
    "demo.pause": "PAUZE",
    "demo.play": "TONEELSTUK",
    "demo.prev": "Vóór",
    "demo.respect": "Respect",
    "demo.thank_you": "Bedankt",
    "demo.tile_admin_users_description": "Beheer de permissions van de admin-gebruiker.",
    "demo.tile_admin_users_label": "Admin-gebruikers",
    "demo.tile_topics_label": "Onderwerpen",
    "developer_tools.email_testing": "E-mail testen",
    "developer_tools.email_testing_description": "Stuur een test-e-mail naar het e-mailadres van je account.",
    "developer_tools.installed_versions": "Geïnstalleerde versies",
    "developer_tools.key": "Sleutel",
    "developer_tools.send_test_email": "Stuur test-e-mail",
    "developer_tools.sending": "Verzenden...",
    "developer_tools.test_email_sent": "Test-e-mail succesvol verzonden via {provider}",
    "developer_tools.title": "Ontwikkelaarstools",
    "developer_tools.translation_queue": "Translation Queue",
    "developer_tools.translation_queue_description": "Process pending translation jobs for the current silo.",
    "developer_tools.translation_queue_done": "Verwerking van de vertaalwachtrij voltooid",
    "developer_tools.translation_queue_locked": "De wachtrij is vergrendeld — een ander proces is al bezig.",
    "developer_tools.translation_queue_process": "Process Queue",
    "developer_tools.translation_queue_processing": "Processing...",
    "developer_tools.translation_queue_result": "Verwerkt: {processed}, Mislukt: {failed}, Overgeslagen: {skipped}",
    "developer_tools.translation_queue_stats": "Taken in wachtrij: {total} ({pending} in afwachting, {failed} mislukt)",
    "developer_tools.unable_to_display": "Niet in staat om omgevingsvariabelen weer te geven.",
    "developer_tools.value": "Waarde",
    "developer_tools.version_client": "Client",
    "developer_tools.version_server": "Server",
    "developer_tools.version_unknown": "Onbekend",
    "dialogue.recording_vote": "Stem wordt opgenomen...",
    "dialogue.response_count": "{total} reacties",
    "dialogue.response_plural": "{count} reacties",
    "dialogue.response_singular": "{count} reactie",
    "dialogue.share_your_thoughts": "Deel je gedachten...",
    "dialogue.skip_submit_vote": "Overslaan en stem indienen",
    "dialogue.update_response": "Werk je reactie bij",
    "dialogue_editable_labels.heading": "Dialoog aanpassen",
    "dialogue_template.description": "Vraag gebruikers om op uw vraag te reageren met een eenvoudig\"ja\"of\"nee\"antwoord.",
    "dialogue_template.label": "Dialoog",
    "disagree": "Oneens",
    "editable_positions_widget.button_label": "Posities bewerken",
    "editable_positions_widget.label": "Positie #{position}",
    "editorial_dash.title": "Redactiedashboard",
    "editorial_experts.with-experts": "Met redactionele experts",
    "editorial_question.be_first": "Wees de eerste om je gedachten te delen",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Doe mee met de discussie",
    "editorial_question.lets_talk": "Laten we het hebben over...",
    "editorial_question.response_singular": "antwoord",
    "editorial_question.responses_plural": "antwoorden",
    "editorial_question.share_thoughts": "Deel uw gedachten",
    "error.api": "Er is iets misgegaan",
    "error.network": "Netwerkfout - Controleer uw verbinding met het internet en probeer het opnieuw.",
    "features.srg_section": "SRG",
    "filter_list_popover.trigger_more_filters": "Meer filters",
    "footer.made_by": "Gemaakt door",
    "form.accordion.hide_details": "Verberg details",
    "form.accordion.show_details": "Toon details",
    "form.add_button": "Toevoegen",
    "form.adding_button": "Toevoegen...",
    "form.cancel_button": "Annuleren",
    "form.create_space_button": "Creëer ruimte",
    "form.delete_button": "Verwijderen",
    "form.edit_button": "Bewerking",
    "form.other": "Ander",
    "form.remove_button": "Verwijderen",
    "form.required_label": "{label} (vereist)",
    "form.save_button": "Redden",
    "form.uncheck_all": "Alles deselecteren",
    "form.update_button": "Update",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Gebruiker uitnodigen",
    "invite_user.error": "Uitnodigen van {email} is mislukt. Probeer het opnieuw.",
    "invite_user.modal.editor_subheading": "Nodig iemand uit om een [Editor](https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) te zijn in PSI-tools.",
    "invite_user.modal.email_label": "E-mailadres",
    "invite_user.modal.heading": "Gebruiker uitnodigen",
    "invite_user.modal.invite_button": "Uitnodigen",
    "invite_user.success": "{email} is uitgenodigd.",
    "language.de-CH": "Duits (Zwitserland)",
    "language.de-DE": "Duits",
    "language.en-US": "Engels",
    "language.fr-BE": "Frans (België)",
    "language.fr-CA": "Frans (Canada)",
    "language.fr-CH": "Frans (Zwitserland)",
    "language.fr-FR": "Frans",
    "language.it-CH": "Italiaans (Zwitserland)",
    "language.it-IT": "Italiaans",
    "language.nl-NL": "Nederlands",
    "language.rm-CH": "Reto-Romaans (Zwitserland)",
    "legal.privacy_notice": "Privacyverklaring",
    "legal.terms_of_service": "Servicevoorwaarden",
    "linked_partner_story.incomplete_list_banner": "Deze lijst met verhalen is mogelijk onvolledig.",
    "linked_partner_story.linked_articles_description": "Bekijk verhalen die aan dit gesprek zijn gekoppeld.",
    "linked_partner_story.linked_articles_heading": "Gekoppelde verhalen",
    "linked_partner_story.no_articles_found": "Er zijn nog geen verhalen aan deze ruimte gekoppeld.",
    "linked_partner_story.read_article_link": "Lees artikel",
    "linked_partner_story.view_video_link": "Bekijk video",
    "list.selected_items_count": "{keyCount} Geselecteerde items",
    "llm_ranking.best": "Beste",
    "loading": "Laden...",
    "login.account_blocked_explanation": "Er is geen actie nodig voor de bèta. Alleen een moderator kan uw discussietoegang herstellen.",
    "login.account_blocked_heading": "U kunt niet inloggen omdat uw account is geblokkeerd",
    "login.account_not_impacted": "Uw {siloName} -account is niet beïnvloed en nog steeds toegankelijk.",
    "login.continue_with": "Ga door met {providerName}",
    "login.continue_with_google": "Ga door met Google",
    "login.cookie_notice": "🍪 Deze discussieruimte gebruikt alleen essentiële cookies. We gebruiken geen cookies voor advertentiedoeleinden. [Meer informatie]({privacyNoticeLink}).",
    "login.default_admin_login_heading_label": "Welkom bij {psiBrandName}",
    "login.default_admin_login_subheading_label": "Log in met uw beheerdersaccount om aan de slag te gaan",
    "login.default_login_heading_label": "Een ruimte voor gezonde discussies en verschillende perspectieven",
    "login.dev_login": "Dev Inloggen",
    "login.logging_in": "Inloggen...",
    "login.okay_button": "Oké",
    "login.select_dev_persona": "Selecteer een dev persona",
    "login.sso_error": "Er is iets misgegaan tijdens het inloggen. Sluit dit venster en probeer het opnieuw.",
    "main.checkbox.label": "Nieuwe berichten \"in beoordeling\"",
    "modal.cancel_button": "Annuleren",
    "modal.close_button": "Dichtbij",
    "modal.confirm_leave_button": "Verlaten",
    "modal.info_title": "Info",
    "moddashboard.cannot_reply": "Je kunt niet antwoorden op dit bericht.",
    "moddashboard.cannot_reply_deleted": "Je kunt niet antwoorden op een verwijderd bericht.",
    "moddashboard.failed_to_post_reply": "Plaatsen van antwoord mislukt",
    "moddashboard.publicly_reply_as": "Openbaar antwoorden als",
    "moddashboard.reply_description": "Je antwoord wordt gepubliceerd in de gespreksruimte en is zichtbaar voor alle gebruikers.",
    "moddashboard.reply_posted_successfully": "Je antwoord is succesvol geplaatst",
    "moddashboard.reply_to_user": "Antwoord aan {userName}...",
    "moddashboard.your_reply": "Je antwoord",
    "moderate_dialog.locked_name": "{name} is aan het beoordelen",
    "moderate_spaces.title": "Matig ruimtes",
    "moderation.add_explanation_to_user": "Voeg uitleg toe aan de gebruiker",
    "moderation.admin_bypass_ai_and_manual_moderation": "Deze ruimte heeft AI- en menselijke moderatie ingeschakeld, maar u zult beide automatisch omzeilen als een Admin-gebruiker.",
    "moderation.admin_bypass_ai_moderation": "Deze ruimte heeft AI-moderatie ingeschakeld, maar u zult deze automatisch omzeilen als een Admin-gebruiker.",
    "moderation.admin_bypass_flag": "Je hebt een AI-vlag omzeild",
    "moderation.admin_bypass_manual_moderation": "Deze ruimte heeft menselijke moderatie ingeschakeld, maar u zult deze automatisch omzeilen als een Admin-gebruiker.",
    "moderation.admin_bypassed": "⚠️ AI heeft uw reactie gemarkeerd, maar u heeft deze automatisch omzeild als een Admin-gebruiker.",
    "moderation.admin_filter_notice": "Om de AI-moderatie te verbeteren, stuur een screenshot van je bericht en dit bericht naar je team.",
    "moderation.ai_and_manual_label": "AI en handmatig gemodereerd",
    "moderation.ai_flag": "AI-markering",
    "moderation.ai_mistake_explanation": "AI helpt ons bij het matigen van opmerkingen, maar soms kan het een fout maken. Als AI u verhindert een respectvolle mening te delen, stuur dan uw opmerking naar een moderator voor beoordeling.",
    "moderation.ai_wrong_question": "Heeft AI het fout gehad?",
    "moderation.approved_tag": "Goedgekeurd",
    "moderation.automaticallyApproved": "Automatisch goedgekeurd",
    "moderation.awaitingDecision": "In afwachting van beslissing",
    "moderation.blocked": "Geblokkeerd",
    "moderation.bypassedPremoderation": "Premoderatie omzeild",
    "moderation.check_your_thing": "⚠️ Controleer uw {moderatedThing}",
    "moderation.dash.add_explanation_to_user": "Uitleg toevoegen voor de gebruiker",
    "moderation.dash.approve": "Goedkeuren",
    "moderation.dash.approve_toast": "Succesvol goedgekeurd",
    "moderation.dash.base_filter._rejected": "Handmatig afgewezen",
    "moderation.dash.base_filter.approved": "Goedgekeurd",
    "moderation.dash.base_filter.auto_approved": "Automatisch goedgekeurd",
    "moderation.dash.base_filter.awaiting_decision": "Beslissing afwachten",
    "moderation.dash.base_filter.bypassed_premod": "Omzeilde premoderatie",
    "moderation.dash.base_filter.deleted_by_user": "Verwijderd door gebruiker",
    "moderation.dash.base_filter.manually_approved": "Handmatig goedgekeurd",
    "moderation.dash.base_filter.my_bookmarks": "Mijn bladwijzers",
    "moderation.dash.base_filter.warnings": "Waarschuwingen",
    "moderation.dash.block": "Blokkeren",
    "moderation.dash.block_user": "Blokkeer gebruiker",
    "moderation.dash.blocked": "Geblokkeerd",
    "moderation.dash.blocking_info": "De gebruiker kan niet inloggen op de discussieruimte. Een gebruiker moet 2 keer gewaarschuwd worden voordat ze geblokkeerd kunnen worden.",
    "moderation.dash.cancel_rejection": "Annuleren",
    "moderation.dash.explanation_to_user": "Uitleg voor de gebruiker",
    "moderation.dash.feature_disabled": "Deze functie is uitgeschakeld.",
    "moderation.dash.finish_rejecting": "Voltooi afwijzen",
    "moderation.dash.judgement_card.moderate": "Matig",
    "moderation.dash.operation_error": "Operatie kan niet worden uitgevoerd, probeer het opnieuw",
    "moderation.dash.reject": "Afwijzen",
    "moderation.dash.reject_toast": "Succesvol afgewezen",
    "moderation.dash.select_all_that_apply": "Selecteer alles wat van toepassing is.",
    "moderation.dash.this_account_is_blocked": "🚫 Dit account is geblokkeerd.",
    "moderation.dash.time": "tijd",
    "moderation.dash.times": "tijd",
    "moderation.dash.user_already_warned": "Deze gebruiker is al {count} {noun} gewaarschuwd.",
    "moderation.dash.user_must_be_warned_2_times": "Een gebruiker moet 2 keer worden gewaarschuwd voordat hij kan worden geblokkeerd.",
    "moderation.dash.user_successfully_blocked": "{user} met succes geblokkeerd",
    "moderation.dash.user_successfully_unblocked": "{user} was met succes ongeblokkeerd",
    "moderation.dash.user_successfully_warned": "{user} succesvol gewaarschuwd",
    "moderation.dash.warn_or_block_user": "Waarschuw of blokkeer gebruiker?",
    "moderation.dash.warn_user": "Waarschuw gebruiker",
    "moderation.dash.warning_email_info": "De gebruiker ontvangt een e-mailmelding dat ze zijn gewaarschuwd. U kunt de waarschuwing later van het account van de gebruiker verwijderen.",
    "moderation.dash.what_guidelines_violated": "Welke richtlijnen schendt deze opmerking?",
    "moderation.deletedByUser": "Verwijderd door gebruiker",
    "moderation.deletedUser": "Verwijderde gebruiker",
    "moderation.edit_your_post_button": "Bewerk je bericht",
    "moderation.email_notification": "U ontvangt een e-mailmelding wanneer uw bericht wordt goedgekeurd of afgewezen door moderators.",
    "moderation.email_notification_notice": "U ontvangt een e-mailmelding wanneer uw bericht wordt goedgekeurd of afgewezen door moderators.",
    "moderation.explanations_sent_by_email": "Uitleg wordt per e-mail rechtstreeks naar de gebruiker verzonden nadat u hebt afgewezen.",
    "moderation.heated": "Heet",
    "moderation.incompatible_warning": "AI Review heeft aangetoond dat uw {moderatedThing} mogelijk niet compatibel is met de volgende [Gemeenschapsrichtlijnen]($onPress): ",
    "moderation.infoBannerLoader.label": "Bezig met het beoordelen van je reactie...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Om een gastvrije en respectvolle omgeving te behouden, worden alle berichten in deze ruimte zowel door AI als handmatig gemodereerd voordat ze worden gepubliceerd om ervoor te zorgen dat ze voldoen aan de [Communityrichtlijnen]($onPress)",
    "moderation.info_ai_moderation_banner_text": "Om een gastvrije en respectvolle omgeving te behouden, gebruikt deze ruimte AI om reacties te helpen modereren. AI kan uw bericht markeren voor aanvullende beoordeling als het niet voldoet aan de [Communityrichtlijnen]($onPress)",
    "moderation.info_manual_moderation_banner_text": "Om een gastvrije en respectvolle omgeving te behouden, worden alle berichten in deze ruimte handmatig gemodereerd voordat ze worden gepubliceerd om te voldoen aan de [Communityrichtlijnen]($onPress)",
    "moderation.liveThread": "Live draad",
    "moderation.manuallyApproved": "Handmatig goedgekeurd",
    "moderation.manuallyRejected": "Handmatig afgewezen",
    "moderation.message_to_moderator_placeholder": "Bericht aan moderator...",
    "moderation.mode_ai": "AI-moderatie",
    "moderation.mode_ai_and_manual": "AI- en handmatige moderatie",
    "moderation.mode_ai_post_anyway": "AI-moderatie met toch posten",
    "moderation.mode_manual": "Handmatige moderatie",
    "moderation.new": "Nieuw",
    "moderation.perspective_label": "perspectief label",
    "moderation.popular": "Populair",
    "moderation.post_without_editing_button": "Plaatsen zonder bewerken",
    "moderation.postedAnyway": "Toch geplaatst",
    "moderation.provide_details_help": "Geef details aan om ons te helpen bepalen of uw bericht de richtlijnen voor de gemeenschap volgt.",
    "moderation.rejected_by_moderator": "Afgewezen door moderator",
    "moderation.reported_by_n_users": "Gerapporteerd door {count} gebruikers",
    "moderation.response": "antwoord",
    "moderation.select_all_that_apply": "Selecteer alles wat van toepassing is.",
    "moderation.send_for_review_button": "Stuur voor beoordeling naar een moderator",
    "moderation.send_to_moderator_button": "Stuur naar Moderator",
    "moderation.send_to_moderator_title": "Stuur naar Moderator",
    "moderation.sending": "Verzenden...",
    "moderation.sent_for_review_message": "Uw antwoord is ter beoordeling naar een moderator gestuurd.",
    "moderation.sent_to_moderator": "Uw antwoord is ter beoordeling naar een moderator gestuurd.",
    "moderation.sent_to_moderator_time": "Verzonden naar moderator: {time}",
    "moderation.share_details": "Details delen",
    "moderation.singularTerm": "Enkelvoudige term",
    "moderation.strict_filter_notice": "⚠️ Ons moderatiefilter is momenteel vrij streng om het hoogste veiligheidsniveau te garanderen! Als u denkt dat uw bijdrage oneerlijk wordt afgewezen, neem dan contact op met ons moderatieteam!",
    "moderation.system_unavailable_message": "Ons AI-moderatiesysteem is tijdelijk niet beschikbaar. U kunt uw bericht nog steeds naar een menselijke moderator sturen voor beoordeling.",
    "moderation.system_unavailable_title": "⚠️ Moderatiesysteem tijdelijk niet beschikbaar",
    "moderation.take_second_look_rephrase": "📢 Overweeg je bericht anders te formuleren om een breder publiek te bereiken en meer betekenisvolle discussies te stimuleren.",
    "moderation.take_second_look_title": "Bekijk het nog eens",
    "moderation.take_second_look_warning": "❗️ Onze AI-review suggereert dat je reactie mensen kan afschrikken die jouw standpunt niet delen.",
    "moderation.thank_you": "Bedankt!",
    "moderation.under_review": "Beoordeling",
    "moderation.update_without_editing_button": "Bijwerken zonder te bewerken",
    "moderation.use_ai_title": "✨ We gebruiken AI voor moderatie",
    "moderation.warned": "Gewaar-schuwd",
    "moderation.what_guideline_violate": "Welke richtlijnen schendt deze opmerking?",
    "moderation.what_happens_next": "📫 Wat gebeurt er daarna",
    "moderation.write_additional_explanation": "Schrijf een extra uitleg voor de gebruiker over uw afwijzing.",
    "moderation.zdfComment": "ZDF-opmerking",
    "moderation_card.auto_translated": "Automatisch vertaald",
    "moderation_card.language_tag": "{locale} | Vertaald",
    "moderation_card.origin": "Oorsprong:",
    "moderation_card.origin_not_available": "Geen oorsprong beschikbaar",
    "moderation_card.show_original": "Origineel weergeven ({locale})",
    "moderation_card.show_translation": "Vertaling weergeven ({locale})",
    "moderation_dash.add_your_notes": "Voeg je notities toe...",
    "moderation_dash.blocklist": "Blokkeerlijst",
    "moderation_dash.channel_settings": "Kanaalinstellingen",
    "moderation_dash.community_guideline_violation": "⚠️ Overtreding van de gemeenschapsrichtlijnen",
    "moderation_dash.count_users": "{count} gebruikers",
    "moderation_dash.created_by": "Gemaakt door",
    "moderation_dash.explanation_to_user": "Uitleg aan de gebruiker",
    "moderation_dash.internal_notes": "Interne notities",
    "moderation_dash.manually_rejected": "Handmatig afgewezen",
    "moderation_dash.message_to_moderator": "Bericht aan moderator",
    "moderation_dash.moderate_spaces": "Matig ruimtes",
    "moderation_dash.no_spaces": "Nog geen ruimtes",
    "moderation_dash.num_stories": "{numArticles} verhalen",
    "moderation_dash.posts": "Berichten",
    "moderation_dash.posts.title": "Berichten modereren",
    "moderation_dash.premod_eval_tab": "AI-evaluatie",
    "moderation_dash.queue.all_posts_hidden_plural": "{count} berichten zijn verborgen door de bovenstaande filters.",
    "moderation_dash.queue.all_posts_hidden_singular": "1 bericht is verborgen door de bovenstaande filters.",
    "moderation_dash.queue.load_more": "Meer laden",
    "moderation_dash.queue.no_posts_yet": "Er zijn nog geen berichten.",
    "moderation_dash.rejected_by": "Afgewezen door",
    "moderation_dash.reported_by": "Gerapporteerd door",
    "moderation_dash.selected_community_guideline_violation": "⚠️ Geselecteerde schending van de communityrichtlijnen",
    "moderation_dash.user_report": "Gebruikersrapport",
    "moderation_queue.button_filters": "Filters",
    "moderation_queue.clear_all": "Alles wissen",
    "moderationdash.title": "Matiging dashboard",
    "moderationdash.user_information": "Gebruikersinformatie",
    "moderationdash.user_metadata.comments_and_replies": "Berichten:",
    "moderationdash.user_metadata.flagged_comments": "AI-gemarkeerde berichten:",
    "moderationdash.user_metadata.rejected_comments": "Afgewezen berichten:",
    "moderationdash.user_metadata.reported_comments": "Gerapporteerde berichten:",
    "moderationdash.user_metadata.user_warnings": "Waarschuwingen:",
    "moderationtag.manually_moderated": "Handmatig gemodereerd",
    "most_popular.most_popular_label": "Het meest populair",
    "most_popular.most_recent_label": "Meest recent",
    "most_popular.show_more_button": "Toon meer reacties",
    "navigation_header.back_button": "Rug",
    "neutral": "Neutraal",
    "notification.dismiss_button": "Afwijzen",
    "notification.new_moderation_tasks": "Meldingen over nieuwe moderatortaken die klaarstaan voor beoordeling",
    "notification.new_moderation_tasks_settings": "Instellingen voor meldingen over nieuwe moderatortaken die klaarstaan voor beoordeling",
    "notification.new_moderation_tasks_settings.checkboxMyChannels": "... in mijn kanalen",
    "notification.new_moderation_tasks_settings.checkboxSpacesICreated": "... in ruimtes die ik heb aangemaakt",
    "notification.new_moderation_tasks_settings.checkboxSpacesIFollow": "... in ruimtes die ik volg",
    "onboarding.dismiss_button": "Sluiten",
    "original_language": "Oorspronkelijke taal",
    "pagination_row.next_page": "Volgende pagina",
    "pagination_row.previous_page": "Vorige pagina",
    "pagination_row.showing": "Toont {start}-{end} van {total}",
    "perspectives.add_new_perspective": "Voeg een nieuw perspectief toe",
    "perspectives.add_your_own": "Voeg die van jezelf toe",
    "perspectives.add_your_perspective": "Voeg je perspectief toe",
    "perspectives.dont_see_one": "Zie je er geen die past?",
    "perspectives.edit_invalid_characters": "Perspectieflabels moeten minstens één letter bevatten",
    "perspectives.enter_label_placeholder": "Voer een perspectiefetiket in",
    "perspectives.havent_heard_yet": "We hebben nog niets van deze perspectieven gehoord",
    "perspectives.how_relate_question": "Hoe verhoudt u zich tot dit probleem?",
    "perspectives.poll_title": "Van wie we hebben gehoord",
    "perspectives.share_thoughts_button": "Deel uw gedachten",
    "perspectives.title": "Perspectieven",
    "perspectives.write_in_duplicate": "Dit perspectief bestaat al — kies het uit de lijst",
    "perspectives.write_in_empty": "Voer een perspectieflabel in",
    "perspectives.write_in_invalid_characters": "Perspectieflabels moeten minstens één letter bevatten",
    "perspectives.write_in_no_emoji": "Emoji zijn niet toegestaan in eigen perspectieven",
    "perspectives.write_in_too_long": "Perspectieflabels mogen uit maximaal {max} tekens bestaan",
    "pin_comment.feature_label": "Functie",
    "pin_comment.featured_label": "Uitgelaten",
    "pin_to_feed.move_down": "Omlaag verplaatsen",
    "pin_to_feed.move_up": "Omhoog verplaatsen",
    "pin_to_feed.pin_label": "Vastzetten",
    "pin_to_feed.pinned_label": "Vastgezet",
    "poll.change_vote_button": "Verander mijn stem",
    "poll.recording_vote": "Stem opnemen...",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (uw stem): {percent}%",
    "poll.submit_vote_button": "Dien mijn stem in",
    "poll.write_in_topic": "Schrijf in een onderwerp...",
    "poll.you": "Jij",
    "poll.you_comment": "Jij ({comment})",
    "poll_question.add_option_button": "Optie toevoegen",
    "poll_question.option_placeholder": "Schrijf uw optie...",
    "poll_question.options_label": "Poll-opties",
    "poll_question.question_label": "Peilvraag",
    "poll_question.question_placeholder": "Schrijf uw poll-vraag...",
    "poll_result.percent": "{percent}%",
    "popup.close_button": "Sluit de pop-up",
    "popup_tip.more_information": "Meer informatie",
    "post.post_anyway_button": "Toch posten",
    "post.posting_anyway": "Toch posten...",
    "post.submit": "Indienen",
    "post.submitting": "Bezig met indienen...",
    "post.update": "Bijwerken",
    "post.update_anyway_button": "Toch bijwerken",
    "post.updating": "Bijwerken...",
    "post.updating_anyway": "Toch bijwerken...",
    "premod_review.ai_eval_title": "AI-evaluatie",
    "premod_review.ai_flag_label": "AI-markering",
    "premod_review.badge_ai_correct": "AI correct",
    "premod_review.badge_ai_incorrect": "AI incorrect",
    "premod_review.badge_needs_evaluation": "Beoordeling nodig",
    "premod_review.badge_wrong_reason": "Verkeerde reden",
    "premod_review.based_on_evaluations": "Gebaseerd op {count} \"{verdict}\" evaluaties",
    "premod_review.correct_rules_label": "Correcte regels",
    "premod_review.disabled": "Het verzamelen van gegevens voor pre-moderatiebeoordeling is uitgeschakeld op deze server. Deze functie is standaard ingeschakeld. Om het opnieuw in te schakelen, verwijder PREMOD_REVIEW_DISABLED=true uit .env.",
    "premod_review.empty_state": "Er zijn geen berichten om te evalueren in deze categorie.",
    "premod_review.evaluate_title": "Evalueer AI-markering",
    "premod_review.evaluation_correct": "AI is correct - bericht schendt richtlijnen",
    "premod_review.evaluation_incorrect": "AI is incorrect - bericht moet worden toegestaan",
    "premod_review.evaluation_set_tooltip": "We gebruiken AI om een nieuwe set synthetische berichten te genereren die dezelfde randgevallen vertonen als de echte berichten die hier in de evaluatiegegevens worden getoond.",
    "premod_review.evaluation_submitted_toast": "Uw evaluatie is ingediend",
    "premod_review.evaluation_wrong_reason": "Correct om te blokkeren, maar om de verkeerde reden",
    "premod_review.evaluator_explanation": "Uitleg van de beoordelaar",
    "premod_review.expiration_tooltip": "Reacties verlopen na 30 dagen om te voldoen aan ons privacybeleid.",
    "premod_review.expired": "Verlopen",
    "premod_review.expires_in": "Verloopt over {days}d",
    "premod_review.export_description": "Download een bestand met echt beoordeelde berichten uit deze evaluatiecategorie.",
    "premod_review.export_heading": "Genereer evaluatiegegevens voor download",
    "premod_review.file_format_label": "Bestandsformaat",
    "premod_review.file_ready": "{format} bestand klaar!",
    "premod_review.filter_ai_correct": "AI correct",
    "premod_review.filter_ai_incorrect": "AI incorrect",
    "premod_review.filter_needs_evaluation": "Beoordeling nodig",
    "premod_review.filter_wrong_reason": "Verkeerde reden",
    "premod_review.format_csv": "CSV",
    "premod_review.format_json": "JSON",
    "premod_review.generate_data": "Genereer data",
    "premod_review.loading": "Laden...",
    "premod_review.moderate_posts_description": "Geef feedback op de beslissingen van AI om berichten voor moderatie te markeren. Dit werk bouwt evaluatiedatasets om de nauwkeurigheid van AI's pre-moderatie in de loop van de tijd te verbeteren.",
    "premod_review.post_label": "Bericht",
    "premod_review.reason_description": "Dit zal worden gebruikt om synthetische trainingsgegevens te genereren om de AI te verbeteren.",
    "premod_review.reason_label": "Leg uw evaluatie uit",
    "premod_review.reason_placeholder": "bijv. \"Dit is legitieme beleidskritiek, geen persoonlijke aanval\"",
    "premod_review.regenerate_data": "Genereer data opnieuw",
    "premod_review.select_format": "Selecteer exportformaat",
    "premod_review.select_format_description": "Kies een bestandsformaat voor uw data-export.",
    "premod_review.space_label": "Ruimte",
    "premod_review.submit": "Indienen",
    "premod_review.submitting": "Indienen...",
    "premod_review.which_rules_violated_label": "Welke regels overtreedt deze post eigenlijk?",
    "premod_review.why_not_ai_rules_label": "Waarom schendt de post de door de AI aangehaalde regels niet?",
    "premod_review.why_not_ai_rules_placeholder": "Leg uit waarom de door de AI aangehaalde regels niet van toepassing zijn...",
    "premod_review.why_violates_label": "Waarom schendt de post deze regels?",
    "premod_review.why_violates_placeholder": "Leg uit waarom deze post de door jou geselecteerde regels schendt...",
    "premod_review.your_evaluation": "Uw evaluatie (verplicht)",
    "privacy.only_visible_to_you": "🔒 alleen zichtbaar voor u",
    "profile.add_custom_name": "Voeg een aangepaste naam toe",
    "profile.beta_feedback_note": "Door deel te nemen aan onze bèta, kunt u worden uitgenodigd om feedback over uw ervaring in te dienen met behulp van dit product.",
    "profile.collaboration_note": "Deze discussieruimte wordt georganiseerd door New_ Public, in samenwerking met {psmName}.",
    "profile.consent_aria": "Ik ga akkoord met de Gemeenschapsrichtlijnen, privacy-kennisgeving en servicevoorwaarden.",
    "profile.consent_text": "Ik ga akkoord met de [Gemeenschapsrichtlijnen]({communityGuidelinesLink}), [privacy-kennisgeving]({privacyNoticeLink}) en [voorwaarden van service]({termsOfServiceLink}).",
    "profile.custom_photo_label": "Aangepaste profielfoto",
    "profile.edit.custom-title": "Voeg een aangepaste titel toe",
    "profile.edit.custom_title": "Voeg een aangepaste titel toe",
    "profile.edit.heading": "Bewerken",
    "profile.edit.name": "Profielnaam",
    "profile.edit.name_override": "Naam",
    "profile.edit.name_override.placeholder": "Voeg je aangepaste naam toe...",
    "profile.edit.override_name_title": "Profielnaam overschrijven",
    "profile.edit.override_photo_title": "Profielfoto overschrijven",
    "profile.edit.photo": "Profielfoto",
    "profile.edit.photo_override": "Foto-URL",
    "profile.edit.photo_override.placeholder": "Voeg je aangepaste URL toe...",
    "profile.edit.title": "Titel",
    "profile.edit.windows_title": "Bewerken: {name}",
    "profile.edit_module_button": "Bewerken {tLabel}",
    "profile.editorial_info": "Als Admin-gebruiker kun je meer opties voor je profiel openen in het [Redactioneel Dashboard]({link}).",
    "profile.error_name_empty": "Aangepaste namen kunnen niet leeg zijn.",
    "profile.error_name_invalid": "Aangepaste namen kunnen alleen kleine letters en nummers bevatten.",
    "profile.error_name_looks_real": "Aangepaste namen mogen er niet uitzien als echte namen.",
    "profile.error_name_taken": "Deze aangepaste naam is al in gebruik.",
    "profile.error_name_violates": "Deze aangepaste naam is onverenigbaar met onze gemeenschapsrichtlijnen.",
    "profile.finish_button": "Finish",
    "profile.go_to.edit": "Bewerk overschrijvingen",
    "profile.is_titled_writer": "Is getiteld schrijver",
    "profile.loading": "Profiel laden...",
    "profile.module_name": "Naam",
    "profile.module_photo_and_name": "Foto en naam",
    "profile.name_change_allowed_characters": "Aangepaste namen mogen alleen kleine letters en cijfers bevatten.",
    "profile.name_label": "Profielnaam",
    "profile.no_user_error": "Geen gebruiker gevonden",
    "profile.photo_label": "Uw profielfoto",
    "profile.photo_url_aria": "Foto-URL",
    "profile.photo_url_placeholder": "Foto-URL",
    "profile.please_wait": "Wacht alsjeblieft...",
    "profile.public_overriden": "Uw informatie is bewerkt door een beheerder",
    "profile.setup_title": "Stel uw profiel in",
    "profile.title_heading": "Titel",
    "profile.title_placeholder": "Voer een titel in",
    "profile.username_placeholder": "User123",
    "profile.warn_overriden": "Uw informatie is bewerkt door een beheerder in het [Redactionele Dashboard]({link}).",
    "profile_answers.admins_can_view": "Beheerders en moderators kunnen altijd je geschiedenis bekijken.",
    "profile_answers.discussion_history": "Discussiegeschiedenis",
    "profile_answers.edit_visibility": "Zichtbaarheid bewerken",
    "profile_answers.history_private": "De geschiedenis van deze gebruiker is privé.",
    "profile_answers.load_more": "Meer laden",
    "profile_answers.rejected": "Reactie afgewezen door een moderator",
    "profile_answers.under_review": "Opmerking wordt beoordeeld",
    "profile_answers.visible_to_everyone": "Zichtbaar voor iedereen",
    "profile_menu.dialog_label": "Profielmenu",
    "profile_menu.menu_label": "Account",
    "prosocial_ranking.toggle_label": "Prosociale rangschikking",
    "puppet_test_support.login_user_a": "Inloggen als Gebruiker A",
    "puppet_test_support.login_user_b": "Inloggen als Gebruiker B",
    "puppet_test_support.login_user_c": "Inloggen als Gebruiker C",
    "puppet_test_support.reset_silo": "Reset testsilo",
    "puppet_test_support.secret_label": "Puppet Geheim",
    "puppet_test_support.title": "Puppet Test Tools",
    "question.actions.close_button": "Dichtbij",
    "question.actions.close_confirm_button": "Dichtbij",
    "question.actions.close_modal_description": "Wanneer gesloten, wordt een ruimte 'alleen-lezen'. De meeste acties zijn uitgeschakeld en gebruikers kunnen niet posten, reageren of reageren. Gebruikers kunnen nog steeds opmerkingen rapporteren. Je kunt het gesprek op elk moment heropenen.",
    "question.actions.close_modal_heading": "Deze ruimte sluiten?",
    "question.actions.copy_button": "Kopiëren",
    "question.actions.edit_button": "Bewerking",
    "question.actions.link_copied_toast": "Link gekopieerd naar klembord!",
    "question.actions.linked_stories_button": "Gekoppelde verhalen",
    "question.actions.preview_button": "Voorbeeld",
    "question.actions.publish_button": "Publiceren",
    "question.actions.publish_confirm_button": "Publiceren",
    "question.actions.publish_modal_description": "Zodra gepubliceerd, is deze ruimte zichtbaar voor gebruikers op uw productiesite en vindbaar via SEO. Zorg ervoor dat uw inhoud klaar is voor openbaar gebruik. U kunt het gesprek op elk moment sluiten.",
    "question.actions.publish_modal_heading": "Deze ruimte publiceren?",
    "question.actions.publish_success_toast": "Ruimte gepubliceerd",
    "question.actions.reopen_button": "Heropenen",
    "question.actions.reopen_confirm_button": "Heropenen",
    "question.actions.reopen_modal_description": "Open deze ruimte opnieuw om het gesprek weer actief te maken.",
    "question.actions.reopen_modal_heading": "Deze ruimte opnieuw openen?",
    "question.actions.tooltip": "Meer opties",
    "question.actions.unpublish_button": "Publicatie ongedaan maken",
    "question.actions.unpublish_confirm_button": "Publicatie ongedaan maken",
    "question.actions.unpublish_modal_description": "Zodra niet meer gepubliceerd, is deze ruimte niet langer zichtbaar voor gebruikers op uw productiesite en wordt deze niet meer geïndexeerd voor SEO. U kunt het gesprek op elk moment opnieuw publiceren.",
    "question.actions.unpublish_modal_heading": "Deze ruimte niet meer publiceren?",
    "question.actions.unpublish_success_toast": "Ruimte niet meer gepubliceerd",
    "question.add_content_label": "Inhoud toevoegen",
    "question.add_spaces_label": "Voeg ruimtes toe",
    "question.all_responses_tab": "Alle reacties",
    "question.conversation_format": "Gespreksformaat",
    "question.conversation_helper_section": "Gesprekshulp",
    "question.conversation_type_section": "Gesprekstype",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_closed_banner": "Heropen deze ruimte om deze te bewerken.",
    "question.edit_heading": "Bewerken",
    "question.edit_page_title": "Bewerken: {name}",
    "question.edit_thread_header_section": "Draadkop",
    "question.edit_view_only_banner": "Je kunt de instellingen van deze ruimte bekijken, maar niet wijzigen.",
    "question.error_empty_prompt": "De prompt kan niet leeg zijn.",
    "question.error_prompt_too_long": "De prompt moet minder zijn dan {num} tekens.",
    "question.general_section": "Algemeen",
    "question.input_placeholder": "Deel uw gedachten...",
    "question.moderation_approach": "Moderatiebenadering",
    "question.moderation_label": "Matiging",
    "question.no_comments_message": "Wees de eerste om je gedachten te delen",
    "question.no_comments_title": "Begin het gesprek",
    "question.no_teaser_error": "Geen teaser gedefinieerd",
    "question.not_exist": "Deze vraag bestaat niet",
    "question.playbook_link": "Zie het [Editorial Playbook]({url}) voor begeleiding.",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Prosociaal formaat",
    "question.prosocial_ranking_section": "Prosociale rangschikking",
    "question.public_response_subtitle": "Openbare reactie",
    "question.reaction_list_tooltip": "Zie reacties",
    "question.reaction_plural": "reacties",
    "question.reaction_singular": "reactie",
    "question.reply_placeholder": "Reageer op {authorName}...",
    "question.reply_plural": "antwoorden",
    "question.reply_singular": "antwoord",
    "question.select_format_placeholder": "Selecteer een formaat",
    "question.select_moderation_placeholder": "Selecteer een moderatie-instelling",
    "question.upvote_plural": "stemmen",
    "question.upvote_singular": "verhogen",
    "question.your_response_title": "Uw reactie",
    "ranking-eval.add_ranker": "Rangschikker Toevoegen",
    "ranking-eval.add_source": "Bron toevoegen",
    "ranking-eval.back": "Terug",
    "ranking-eval.builtin_rankers_desc": "Bekijk de prompts van ingebouwde rankers ter referentie bij het maken van je eigen.",
    "ranking-eval.builtin_rankers_title": "Ingebouwde Rankers",
    "ranking-eval.cancel": "Annuleren",
    "ranking-eval.cancel_edit": "Annuleren",
    "ranking-eval.comment_count": "{count} reacties",
    "ranking-eval.comment_scoring_desc": "Beoordeel elke opmerking op een schaal van 1-5 sterren",
    "ranking-eval.comments_random_order": "Opmerkingen in willekeurige volgorde",
    "ranking-eval.conversation_count": "{count} gesprekken",
    "ranking-eval.custom_rankers_desc": "Definieer aangepaste LLM-gestuurde rangschikkers voor gebruik in zij-aan-zij evaluatie. Aangepaste rangschikkers verschijnen in de rangschikker dropdown.",
    "ranking-eval.custom_rankers_title": "Aangepaste Rangschikkers",
    "ranking-eval.delete_ranker": "Verwijderen",
    "ranking-eval.delete_source": "Verwijderen",
    "ranking-eval.disabled": "(uitgeschakeld)",
    "ranking-eval.edit": "Bewerken",
    "ranking-eval.edit_ranker": "Bewerker Rangschikker",
    "ranking-eval.edit_source": "Bron bewerken",
    "ranking-eval.filter.all_sources": "Alle Bronnen",
    "ranking-eval.filter_all": "Alle",
    "ranking-eval.filter_selected": "Geselecteerd",
    "ranking-eval.first_pass_placeholder": "Gebruik {{question}} en {{commentText}}",
    "ranking-eval.first_pass_prompt": "Eerste Pass Prompt",
    "ranking-eval.imported_at": "Opgehaald {time}",
    "ranking-eval.importing": "Gesprek importeren...",
    "ranking-eval.loading_ranker": "Ranker laden...",
    "ranking-eval.model": "Model",
    "ranking-eval.model_placeholder": "Selecteer model",
    "ranking-eval.new_ranker": "Nieuwe Rangschikker",
    "ranking-eval.new_source": "Nieuwe bron",
    "ranking-eval.next_button": "Volgende →",
    "ranking-eval.no_cached": "Nog geen gesprekken in de cache. Druk op \"Vernieuwen van bronnen\" om gesprekken van partnersites op te halen.",
    "ranking-eval.no_comments": "Dit gesprek heeft geen opmerkingen.",
    "ranking-eval.no_conversations_match": "Geen gesprekken komen overeen.",
    "ranking-eval.no_conversations_to_open": "Nog geen gesprekken. Voeg bronnen toe op het tabblad Bronnen en klik vervolgens op \"Vernieuwen vanuit bronnen\" op het tabblad Gespreksset.",
    "ranking-eval.no_custom_rankers": "Nog geen aangepaste rangschikkers. Klik op \"Rangschikker Toevoegen\" om er een te maken.",
    "ranking-eval.no_other_ratings": "Nog geen andere beoordelingen.",
    "ranking-eval.no_ratings_yet": "Nog geen beoordelingen.",
    "ranking-eval.no_sources": "Nog geen bronnen. Klik op \"Bron toevoegen\" om er een toe te voegen.",
    "ranking-eval.no_sources_to_fetch": "Nog geen bronnen. Voeg de PSI-sites waarvan moet worden opgehaald toe op het tabblad Bronnen.",
    "ranking-eval.no_spaces": "Nog geen ruimtes. Voeg er hierboven een toe om te beginnen.",
    "ranking-eval.others_ratings": "Beoordelingen van anderen",
    "ranking-eval.pick_conversation": "Kies gesprek",
    "ranking-eval.prev_button": "← Vorige",
    "ranking-eval.ranker_col.actions": "Acties",
    "ranking-eval.ranker_col.model": "Model",
    "ranking-eval.ranker_col.name": "Naam",
    "ranking-eval.ranker_col.thinking": "Denken",
    "ranking-eval.ranker_col.topn": "Top N",
    "ranking-eval.ranker_desc_placeholder": "Korte beschrijving",
    "ranking-eval.ranker_description": "Beschrijving",
    "ranking-eval.ranker_enabled": "Ingeschakeld",
    "ranking-eval.ranker_name": "Naam",
    "ranking-eval.ranker_name_placeholder": "bijv. Constructieve Discussie",
    "ranking-eval.ranking_scoring": "Reacties beoordelen... {scored} van {total}",
    "ranking-eval.ranking_selecting_top_10": "Top 10 selecteren... dit kan even duren",
    "ranking-eval.ranking_starting": "Rangschikking starten...",
    "ranking-eval.rating_reason_placeholder": "Waarom deze beoordeling?",
    "ranking-eval.reasoning": "Denk Niveau",
    "ranking-eval.reasoning_placeholder": "Selecteer niveau",
    "ranking-eval.refresh": "Verversen vanuit bronnen",
    "ranking-eval.refresh_comments": "Reacties verversen",
    "ranking-eval.refresh_comments_in_progress": "Reacties verversen...",
    "ranking-eval.refresh_in_progress": "Verversen...",
    "ranking-eval.refreshing": "Gesprekken ophalen van partnersites...",
    "ranking-eval.save_ranker": "Opslaan",
    "ranking-eval.save_source": "Opslaan",
    "ranking-eval.scoring_legend_title": "Beoordelingsgids",
    "ranking-eval.search_conversations": "Zoek gesprekken...",
    "ranking-eval.second_pass_placeholder": "Gebruik {{question}} en {{comments}}",
    "ranking-eval.second_pass_prompt": "Tweede Pass Prompt",
    "ranking-eval.select_conversation": "Selecteer gesprek",
    "ranking-eval.select_ranker": "Selecteer rangschikker",
    "ranking-eval.side_by_side_desc": "Vergelijk twee rangschikkingsalgoritmen zij-aan-zij",
    "ranking-eval.source_base_url": "Basis-URL",
    "ranking-eval.source_base_url_placeholder": "bijv. https://psi.newpublic.org",
    "ranking-eval.source_col.actions": "Acties",
    "ranking-eval.source_col.base_url": "Basis-URL",
    "ranking-eval.source_col.key": "Sleutel",
    "ranking-eval.source_col.label": "Label",
    "ranking-eval.source_col.silo": "Silo",
    "ranking-eval.source_key": "Sleutel",
    "ranking-eval.source_key_placeholder": "bijv. np",
    "ranking-eval.source_label": "Label",
    "ranking-eval.source_label_placeholder": "bijv. New Public",
    "ranking-eval.source_remote_silo": "Silo",
    "ranking-eval.source_remote_silo_placeholder": "bijv. np",
    "ranking-eval.sources_desc": "PSI-sites waarvan gesprekken worden opgehaald. \"Vernieuwen vanaf bronnen\" op het tabblad Gespreksset leest ze allemaal uit.",
    "ranking-eval.sources_title": "Bronnen",
    "ranking-eval.sources_unreachable": "Kon {baseUrls} niet bereiken. Controleer of de basis-URL correct is op het tabblad Bronnen.",
    "ranking-eval.spaces.column_actions": "Acties",
    "ranking-eval.spaces.column_comments": "Opmerkingen",
    "ranking-eval.spaces.column_created": "Aangemaakt",
    "ranking-eval.spaces.column_name": "Naam",
    "ranking-eval.spaces.score_comments": "Score Opmerkingen",
    "ranking-eval.spaces.side_by_side": "Zij-aan-Zij",
    "ranking-eval.spaces.title": "Ruimtes",
    "ranking-eval.submit_rating": "Beoordeling Indienen",
    "ranking-eval.tab.comment_scoring": "Commentaar Beoordeling",
    "ranking-eval.tab.conversation_set": "Gesprek Set",
    "ranking-eval.tab.custom_rankers": "Aangepaste Rangschikkers",
    "ranking-eval.tab.side_by_side": "Zij aan Zij",
    "ranking-eval.tab.sources": "Bronnen",
    "ranking-eval.title": "Rangschikking Evaluatie",
    "ranking-eval.top_n": "Top N",
    "ranking-eval.top_n_placeholder": "20",
    "ranking-eval.top_ten_reasoning": "Top 10 redeneringen:",
    "ranking-eval.update_rating": "Beoordeling Bijwerken",
    "ranking-eval.view": "Bekijken",
    "ranking-eval.vote_a_best": "{ranker} is de beste",
    "ranking-eval.vote_b_best": "{ranker} is de beste",
    "ranking-eval.vote_tie": "Gelijk",
    "ranking_debug.recompute": "Rangschikking opnieuw berekenen",
    "ranking_debug.recomputing": "Rangschikking opnieuw berekenen…",
    "ranking_debug.toggle": "Toon rangschikkingsdebuginformatie",
    "ranking_debug.top_ten_reasoning": "Top 10 redenering:",
    "ranking_eval.show_debug_info": "Toon foutopsporingsinformatie",
    "rating.its_complicated": "Het is ingewikkeld",
    "rating.no_with_reservations": "Nee met reserveringen",
    "rating.strongly_no": "Sterk nee",
    "rating.strongly_yes": "Sterk ja",
    "rating.yes_with_reservations": "Ja met reserveringen",
    "reaction_types.appreciation_plural": "waardering",
    "reaction_types.appreciation_singular": "waardering",
    "reaction_types.constructive": "Constructief",
    "reaction_types.controversial": "Controverseel",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Standaard set",
    "reaction_types.empathetic": "Empathisch",
    "reaction_types.enjoyable": "Aangenaam",
    "reaction_types.fun_space": "Leuke ruimte",
    "reaction_types.funny": "Grappig",
    "reaction_types.helpful": "Behulpzaam",
    "reaction_types.insightful": "Inzichtelijk",
    "reaction_types.interesting": "Interessant",
    "reaction_types.nuanced": "Genuanceerd",
    "reaction_types.personal_space": "Persoonlijke ruimte",
    "reaction_types.playful": "Speels",
    "reaction_types.reaction_set_label": "Reactieset",
    "reaction_types.recording": "Reactie opnemen...",
    "reaction_types.relatable": "Herkenbaar",
    "reaction_types.serious_space": "Serieuze ruimte",
    "reaction_types.surprising": "Verrassend",
    "reaction_types.why_appreciate": "Waarom waardeer je dit bericht?",
    "related_content.add_content_button": "Inhoud toevoegen",
    "related_content.article_option": "Artikel",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Ongeldige URL-indeling. Voer een geldige URL in.",
    "related_content.label": "Gerelateerde inhoud",
    "related_content.learn_more": "Lees meer over dit onderwerp",
    "related_content.retrieve_article_error": "Kan artikelinformatie niet ophalen. Controleer de URL en probeer het opnieuw.",
    "related_content.show_more_button": "Laat meer zien",
    "related_content.story_format_label": "Verhaalformaat",
    "related_content.story_url_label": "Verhaal-URL",
    "related_content.url_placeholder": "https://www.example.com",
    "related_content.video_option": "Video",
    "related_conversations.add_hint": "Voeg maximaal vier spaties toe.",
    "related_conversations.add_spaces_button": "Voeg ruimtes toe",
    "related_conversations.limit_reached_error": "Voor deze ruimte zijn al vier gerelateerde ruimtes geselecteerd. Verwijder er een voordat u er nog een toevoegt.",
    "related_conversations.next_button": "Volgende",
    "related_conversations.no_spaces_available": "Geen spaties beschikbaar",
    "related_conversations.no_spaces_found": "Geen spaties gevonden",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "deelnemers",
    "related_conversations.participant_singular": "deelnemer",
    "related_conversations.previous_button": "Vorig",
    "related_conversations.search_placeholder": "Zoekopdracht",
    "related_conversations.title": "Gerelateerde gesprekken",
    "representing_perspectives_template.description": "Vraag gebruikers van een specifieke reeks perspectieven om op uw vraag te reageren.",
    "representing_perspectives_template.description_1": "Kies **3-5 specifieke perspectieven** waar je van wilt horen (bijv. \"🏖️ Gepensioneerde,\" \"📦 Nieuwe inwoner,\" \"🍼 Werkende ouder,\" etc.)",
    "representing_perspectives_template.description_2": "**Vermijd demografisch gebaseerde perspectieven** (bijv. \"stedelijk,\" \"laag inkomen,\" \"vrouw,\" etc.) die tot stereotypen kunnen leiden",
    "representing_perspectives_template.description_3": "**Voorkom het voorschrijven van overtuigingen aan perspectieven** (bijv. \"persoon met een conservatieve houding,\" of \"voorstanders\" en \"tegenstanders\")",
    "representing_perspectives_template.description_4": "**Kies een emoji** voor elk perspectief",
    "representing_perspectives_template.description_5": "Afzonderlijke perspectieven met een lijnpauze.",
    "representing_perspectives_template.form_field_label": "Perspectieven",
    "representing_perspectives_template.helper_label": "Defineer uw perspectieven",
    "representing_perspectives_template.label": "Perspectieven vertegenwoordigen",
    "representing_perspectives_template.placeholder": "Schrijf 3-5 perspectieven...",
    "roles.editor": "Editor",
    "roles.moderator": "Moderator",
    "roles.observer": "Waarnemer",
    "roles.owner": "Eigenaar",
    "roles.unknown": "Onbekend",
    "satisfaction_survey_popover.question": "Hoe tevreden ben je met dit gespreksplatform?",
    "satisfaction_survey_popover.satisfied_label": "Zeer tevreden",
    "satisfaction_survey_popover.unsatisfied_label": "Zeer ontevreden",
    "saving": "Besparing...",
    "search.no_members_found": "Geen leden gevonden",
    "search.placeholder": "Zoekopdracht...",
    "settings.add_feature_button": "Functie toevoegen",
    "settings.add_format_button": "Formaat toevoegen",
    "settings.add_to_organization_button": "Toevoegen aan organisatie",
    "settings.added_button": "Toegevoegd",
    "settings.added_format_button": "Toegevoegd",
    "settings.additional_features_heading": "Aanvullende functies",
    "settings.ai_and_manual_moderation_description": "Vereis dat alle door gebruikers ingediende berichten zowel door AI als door mensen worden beoordeeld voordat ze worden gepubliceerd.",
    "settings.ai_pre_moderation_description": "Gebruik AI om ervoor te zorgen dat door gebruikers ingediende berichten voldoen aan de Communityrichtlijnen voordat ze worden gepubliceerd.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Sta gebruikers toe berichten te publiceren die door AI als van lage kwaliteit maar niet schadelijk worden gecategoriseerd, en rangschik ze lager in de feed.",
    "settings.audience_input_description": "Verzamel vragen, getuigenissen en verhalen van gebruikers. Dit zorgt voor een groter bereik van betrokkenheid.",
    "settings.audience_input_label": "Invoer van publiek",
    "settings.blocklist_description": "Blokkeer specifieke woorden van alle door de gebruiker ingediende berichten.",
    "settings.blocklist_label": "Blocklist",
    "settings.channels_description": "Organiseer ruimtes in verschillende kanalen, zodat redactionele en moderatieteams zich kunnen concentreren op relevante inhoud.",
    "settings.channels_label": "Kanalen",
    "settings.comment_slider_description": "Vraag gebruikers om op uw vraag te reageren langs een spectrum (bijvoorbeeld\"sterk nee\"naar\"sterk ja\").",
    "settings.comment_slider_label": "Commentaar schuifregelaar",
    "settings.conversation_home": "Gesprekken Home",
    "settings.conversation_home_description": "Publieke pagina die alle actieve en gesloten gesprekken uit de silo toont",
    "settings.dialogue_description": "Vraag gebruikers om op uw vraag te reageren met een eenvoudig\"ja\"of\"nee\"antwoord.",
    "settings.dialogue_label": "Dialoog",
    "settings.heading": "{psiBrandName} Instellingen",
    "settings.labs_description": "Prosociale formaten in eerdere ontwikkelingsstadia, beschikbaar voor experimenten. Labs-functies zijn volledig functioneel, maar missen gestandaardiseerde standaardwaarden en kunnen in de loop van de tijd veranderen.",
    "settings.labs_heading": "Laboratorium",
    "settings.manual_moderation_description": "Vereis dat alle door gebruikers ingediende berichten door mensen worden beoordeeld voordat ze worden gepubliceerd; gebruikt helemaal geen AI voor moderatie.",
    "settings.moderation_heading": "Matiging",
    "settings.premod_review_tab_description": "Voeg een tabblad toe aan het moderatiedashboard waar moderators elke beslissing van de AI beoordelen en vastleggen of die juist was.",
    "settings.premod_review_tab_label": "AI-evaluatietabblad",
    "settings.prosocial_formats_description": "Elke discussieruimte wordt gestructureerd door een prosociaal geleid formaat.",
    "settings.prosocial_formats_heading": "Prosociale formaten",
    "settings.prosocial_ranking_description": "Plaats automatisch de meest inzichtelijke en constructieve reacties bovenaan de feed.",
    "settings.prosocial_ranking_label": "Prosociale rangschikking",
    "settings.representing_perspectives_description": "Vraag gebruikers van een specifieke reeks perspectieven om op uw vraag te reageren.",
    "settings.representing_perspectives_label": "Perspectieven vertegenwoordigen",
    "settings.stories_description": "Koppel gepubliceerde verhaal-URL's aan gespreksruimtes, zodat een ingesloten gesprek wordt geladen op de pagina's die je kiest. Vereist aanvullende configuratie door een ontwikkelaar.",
    "settings.stories_label": "Verhalen",
    "settings.titled_writers_description": "Identificeer geselecteerde gebruikers als geverifieerde leden van uw organisatie bij het schrijven van opmerkingen of reageren op anderen.",
    "settings.titled_writers_label": "Getiteld schrijvers",
    "settings.video_voting_description": "Overlay vragen over video-inhoud.",
    "settings.video_voting_label": "Video-stemmen",
    "simple_ranking.most_reactions": "De meeste reacties",
    "simple_ranking.newest": "Nieuwste",
    "single_response_help.same_question_title": "Dezelfde vraag, nieuw artikel?",
    "single_response_help.update_response_label": "Werk uw vorige reactie bij met nieuwe inzichten",
    "slider_with_stop_points.aria_label": "Gebruik links en rechts of omhoog en omlaag pijltoetsen om de schuifregelaar aan te passen",
    "sort.all": "Alle",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Meest recent",
    "sort.top": "Bovenkant",
    "sort.top_voted": "Hoogst gestemd",
    "sort_button.aria_label": "Sorteren op {text}",
    "sort_menu.sort_by_header": "Sorteren op",
    "sorting.most_recent": "Meest recent",
    "sorting.oldest": "Oudste",
    "space.detail.id": "ID:",
    "space.detail.linkes.stories": "Gekoppelde verhalen:",
    "space.detail.posts": "Berichten:",
    "space.table.demo.name": "Naam",
    "space.table.demo.responses": "Antwoorden",
    "space.table.search": "Zoekopdracht...",
    "spaces.column_actions": "Acties",
    "spaces.column_comments": "Berichten",
    "spaces.column_created": "Gecreëerd",
    "spaces.column_creationDate": "Gemaakt",
    "spaces.column_format": "Formaat",
    "spaces.column_name": "Naam",
    "spaces.column_needs_review": "Moet worden beoordeeld",
    "spaces.column_notification_follow": "Volgen",
    "spaces.column_notification_following": "Volgend",
    "spaces.column_notifications": "Meldingen",
    "spaces.column_responses": "Antwoorden",
    "spaces.column_status": "Status",
    "spaces.draft_created": "Conceptruimte aangemaakt",
    "spaces.draft_not_created": "Fout: conceptruimte niet aangemaakt",
    "spaces.filter_active": "Actief",
    "spaces.filter_closed": "Gesloten",
    "spaces.filter_draft": "Concept",
    "spaces.filter_heated": "Verwarmd",
    "spaces.filter_needs_review": "Moet worden beoordeeld",
    "spaces.format_required_label": "Prosociaal formaat (vereist)",
    "spaces.kickstart_conversation_tip": "Geef deze conversatie een vliegende start door ten minste drie opmerkingen toe te voegen.",
    "spaces.new_button": "Nieuwe ruimte",
    "spaces.new_space_title": "Nieuwe ruimte",
    "spaces.no_spaces_found": "Geen spaties gevonden",
    "spaces.no_spaces_yet": "Nog geen ruimtes",
    "spaces.no_templates_message": "Geen sjablonen beschikbaar",
    "spaces.prompt_help_avoid": "Vermijd:",
    "spaces.prompt_help_avoid_1": "Sturende vragen",
    "spaces.prompt_help_avoid_2": "Puur theoretische onderwerpen",
    "spaces.prompt_help_good_prompts": "Goede aanwijzingen zijn:",
    "spaces.prompt_help_tip_1": "Tijdig, specifiek, cultureel relevant",
    "spaces.prompt_help_tip_2": "Open voor debat en discussie",
    "spaces.prompt_help_tip_3": "Duidelijk en open, maar niet abstract",
    "spaces.prompt_help_title": "Hulp nodig bij schrijven?",
    "spaces.prompt_label": "Prompt",
    "spaces.prompt_placeholder": "Schrijf een vraag of discussieprompt...",
    "spaces.status_active": "Actief",
    "spaces.status_closed": "Gesloten",
    "spaces.status_draft": "Concept",
    "spaces.still_need_help": "Nog steeds hulp nodig?",
    "spaces.tab_label": "Draden",
    "spaces.title": "Draden",
    "spaces.visit_playbook": "Bezoek de PSI Playbook",
    "srg.profile.error_name_invalid": "Aangepaste namen kunnen alleen letters, cijfers, spaties en streepjes bevatten.",
    "standalone_question.participant": "deelnemer",
    "standalone_question.participants": "deelnemers",
    "status.creation_successful": "Creatie succesvol",
    "status.edit_successful": "Bewerking succesvol",
    "status.reload_to_see_effect": "Herlaad het artikel om het effect te zien",
    "status.reported": "Gerapporteerd",
    "story_dash.action_attach_spaces": "Ruimtes koppelen",
    "story_dash.action_edit_spaces": "Gekoppelde ruimtes bewerken",
    "story_dash.action_remove": "Verwijderen",
    "story_dash.action_view": "Bekijk verhaal",
    "story_dash.actions_column": "Acties",
    "story_dash.add_story_button": "Verhaal toevoegen",
    "story_dash.add_title": "Verhaal toevoegen",
    "story_dash.attach_space_label": "Ruimtes",
    "story_dash.attach_space_modal_heading": "Ruimtes koppelen",
    "story_dash.attach_spaces": "Ruimtes koppelen",
    "story_dash.attach_spaces_button": "Ruimtes koppelen",
    "story_dash.attach_spaces_description": "Koppel bestaande ruimte(s) aan dit verhaal.",
    "story_dash.attach_spaces_modal_description": "Koppel bestaande ruimte(s) aan dit verhaal.",
    "story_dash.attached_spaces_more": "+{count} meer",
    "story_dash.cancel_button": "Annuleren",
    "story_dash.connected_space_column": "Verbonden ruimtes",
    "story_dash.create_button": "Verhaal toevoegen",
    "story_dash.date_column": "Gepubliceerd",
    "story_dash.domains_column": "Domeinen",
    "story_dash.filter_all": "Alle",
    "story_dash.invalid_url_error": "Voer een geldige URL in",
    "story_dash.name_column": "Naam",
    "story_dash.no_matches": "Geen verhalen komen overeen met uw zoekopdracht.",
    "story_dash.no_stories": "Nog geen verhalen. Voeg een verhaal toe om te beginnen.",
    "story_dash.remove_confirm_button": "Verwijderen",
    "story_dash.remove_modal_description": "Deze actie kan niet ongedaan worden gemaakt. Alle gekoppelde ruimte(s) zullen worden losgekoppeld.",
    "story_dash.remove_modal_description_2": "Je kunt het verhaal op elk moment opnieuw toevoegen en aan een ruimte koppelen.",
    "story_dash.remove_modal_heading": "Dit verhaal verwijderen?",
    "story_dash.save_button": "Opslaan",
    "story_dash.search": "Zoeken...",
    "story_dash.search_placeholder": "Zoeken...",
    "story_dash.spaces_updated_toast": "Ruimtes bijgewerkt",
    "story_dash.story_added_toast": "Verhaal toegevoegd",
    "story_dash.story_removed_toast": "Verhaal verwijderd en ruimte(s) losgekoppeld",
    "story_dash.story_url_label": "Verhaal-URL",
    "story_dash.tab": "Verhalen",
    "story_dash.table_heading": "Verhalen",
    "story_dash.url_description": "Voeg een artikel, video of ander medium toe.",
    "story_dash.url_placeholder": "www.voorbeeld.com",
    "strongly_agree": "Sterk mee eens",
    "strongly_disagree": "Zeer oneens",
    "survey.feedback_help": "Uw feedback helpt ons om uw ervaring te verbeteren.",
    "survey.strongly_agree": "Sterk mee eens",
    "survey.strongly_disagree": "Zeer oneens",
    "survey.tell_us_experience": "Vertel ons over uw ervaring",
    "survey.thank_you": "Bedankt voor het delen van uw ervaring met ons!",
    "suspension.block_user_confirm": "Blokkeer {userName}?",
    "suspension.block_user_description": "De gebruiker zal niet kunnen inloggen in de discussieruimte.",
    "suspension.moderator_blocked_you": "Een moderator heeft je geblokkeerd",
    "suspension.moderator_unblocked_you": "Een moderator deblokkeerde je",
    "suspension.moderator_unwarned_you": "Een moderator heeft je gewaarschuwd",
    "suspension.moderator_warned_you": "Een moderator waarschuwde je",
    "suspension.unblock_user_confirm": "Deblokkeer {userName}?",
    "suspension.unblock_user_description": "De gebruiker zal weer kunnen deelnemen aan de discussieruimte.",
    "table_grid.empty": "Nog niets hier",
    "tag.beta": "Bèta",
    "template.perspectives_description": "Afzonderlijke perspectieven met een lijnpauze.",
    "template.perspectives_label": "Perspectieven",
    "text.character_count": "{count}/{max} tekens",
    "text.character_count_max": "{count}/{max} Tekens max",
    "text.character_count_min": "{min} tekens min",
    "text.character_count_over_max": "{count}/{max} Tekens max",
    "text.character_count_progress_min": "{count}/{min} tekens min",
    "tile.experimental_label": "Bèta",
    "tile.outdated_label": "Verouderd",
    "time.format": "{time}",
    "upvote.aria_label": "Verhogen",
    "upvote.count": "{count}",
    "upvote.recording": "Upvote opnemen...",
    "usability_survey.easy_to_use_question": "Dit gespreksplatform is gemakkelijk te gebruiken",
    "usability_survey.meets_needs_question": "Dit gespreksplatform voldoet aan mijn behoeften",
    "user.member": "Lid",
    "user_info.account_button": "Rekening",
    "user_info.admin": "Beheerder",
    "user_info.developer_features": "Ontwikkelaarsfuncties",
    "user_info.faqs": "Veelgestelde vragen",
    "user_info.log_in_button": "Inloggen",
    "user_info.log_out_button": "Uitloggen",
    "user_info.profile_button": "Profiel",
    "user_info.profile_menu_aria_label": "Profielmenu voor {name}",
    "video_link.go_to_video": "Ga naar video",
    "video_voting.community_average": "Gemeenschappelijk gemiddelde",
    "video_voting.continue_button": "Doorgaan",
    "video_voting.create_new_voting": "Creëer een nieuw stemmen",
    "video_voting.current_session_state": "Huidige sessiestaat Object",
    "video_voting.deactivate_all": "Je kunt het deactiveren voor alle video's.",
    "video_voting.discourse": "Gesprek",
    "video_voting.edit_title": "Bewerk Video stemmen",
    "video_voting.enable_all_videos": "Schakel voor alle video's in",
    "video_voting.enable_voting": "Schakel stemmen in",
    "video_voting.intro_text": "Deze video bevat publieksvragen waaraan u kunt deelnemen. U kunt anoniem stemmen, individuele vragen overslaan of deze functie uitschakelen. In de",
    "video_voting.join_discussion": "Doe mee met de discussie",
    "video_voting.manage_voting_admin": "Beheer stemmen (admin)",
    "video_voting.no_data_available": "Geen stemgegevens beschikbaar.",
    "video_voting.no_main_screen": "Geen hoofdscherm voor videostemmen gedefinieerd.",
    "video_voting.no_question_overlay": "Geen vraagoverlay getoond",
    "video_voting.no_space_selected": "Selecteer een ruimte voor deze stemming voordat je opslaat.",
    "video_voting.not_logged_in_text": "U moet worden aangemeld om deze functie te gebruiken.\nDe video speelt zoals gewoonlijk en je zult geen stemmen zien.**Klik hier om in te loggen**.",
    "video_voting.preview_admin": "Voorbeeld Video Voting (Admin)",
    "video_voting.select_voting_for_article": "Selecteer een stem voor dit artikel",
    "video_voting.settings": "instellingen",
    "video_voting.start_video": "Start video",
    "video_voting.template_missing": "De video-stemming-sjabloon ontbreekt",
    "video_voting.time": "Tijd:",
    "video_voting.title": "Video-stemmen",
    "video_voting.vote_anonymously": "Stem anoniem",
    "video_voting.votings_tab": "Stemmen",
    "video_voting.waiting_for_video": "Wachten tot video geladen is!",
    "video_voting.you": "Jij",
    "videoplayer_demo.pause": "PAUZE",
    "videoplayer_demo.play": "AFSPELEN",
    "videoplayer_demo.seek_60": "ZOEK NAAR 60 SECONDEN",
    "videovoting.select_chapter": "Selecteer een hoofdstuk",
    "videovoting.select_existing_voting": "Selecteer een bestaande Video Voting",
    "videovoting.select_question": "Selecteer een vraag",
    "visibility.only_visible_to_admins": "Alleen zichtbaar voor beheerders",
    "vote.delete_button": "Verwijderen",
    "vote.delete_modal_heading": "Weet je zeker dat je je stem wilt verwijderen?",
    "vote.delete_modal_warning": "Deze actie kan niet ongedaan worden gemaakt.",
    "voting.no": "Nee",
    "voting.yes": "Ja",
    "zdf_admin.votings": "Stemmen",
    "zdf_article.manage_teaser_positions": "Beheer teaser-posities",
    "zdf_article.pick_positions": "Pak maximaal 2 posities",
    "zdf_article.teaser_position_last_paragraph": "Na de laatste paragraaf in de hoofdtekst",
    "zdf_article.teaser_position_second_paragraph": "Na de tweede paragraaf in de hoofdtekst",
    "zdf_article.teaser_position_second_subheading": "Na het tweede onderdeel in de hoofdtekst",
    "zdf_channels.add_channel_title": "Voeg een kanaal toe",
    "zdf_channels.add_members": "Voeg leden toe",
    "zdf_channels.all_channels_roles_access": "Eigenaren en Editors hebben toegang tot dit kanaal.",
    "zdf_channels.channel_name_error": "Voer een kanaalnaam in.",
    "zdf_channels.channel_name_label": "Kanaalnaam",
    "zdf_channels.default_channel_access": "Alle admin-gebruikers hebben toegang tot het standaardkanaal.",
    "zdf_channels.default_channel_explanation": "Alle beheerders hebben toegang tot het standaardkanaal.\n\nNieuwe vragen die niet aan een specifiek kanaal zijn toegewezen, worden toegewezen aan het standaardkanaal.\n\nEr kan slechts één standaardkanaal zijn.",
    "zdf_channels.delete_channel_title": "Verwijder kanaal",
    "zdf_channels.delete_confirmation": "Moet dit kanaal echt worden verwijderd?",
    "zdf_channels.edit_channel_title": "Bewerkingskanaal bewerken",
    "zdf_channels.image_url_error": "Voer een volledige afbeeldings-URL in, beginnend met https://.",
    "zdf_channels.image_url_label": "Afbeelding URL",
    "zdf_channels.member_search_field": "Ledenzoekveld",
    "zdf_channels.members_label": "Leden",
    "zdf_channels.use_as_default": "Gebruik als standaardkanaal",
    "zdf_moddashboard.ai_explanation": "AI-uitleg",
    "zdf_videovoting.no_session": "**Geen sessie geïnitialiseerd**",
    "zdf_videovoting.poll_type": "Peiling",
    "zdf_videovoting.slider_type": "Schuifregelaar",
    "zdf_videovoting_editor.add_chapter": "Voeg Hoofdstuk Toe",
    "zdf_videovoting_editor.add_option": "Voeg Optie Toe",
    "zdf_videovoting_editor.add_predetermined_answer": "Voeg een vooraf bepaald antwoord toe",
    "zdf_videovoting_editor.add_question": "Voeg Vraag Toe",
    "zdf_videovoting_editor.answer_label": "Antwoordlabel",
    "zdf_videovoting_editor.answer_value": "Antwoordwaarde",
    "zdf_videovoting_editor.assign_chapter": "Wijs een hoofdstuk toe",
    "zdf_videovoting_editor.assign_space": "Wijs een ruimte toe",
    "zdf_videovoting_editor.chapters": "Hoofdstukken:",
    "zdf_videovoting_editor.layout": "Indeling:",
    "zdf_videovoting_editor.maximum_value": "Maximale waarde",
    "zdf_videovoting_editor.minimum_value": "Minimale waarde",
    "zdf_videovoting_editor.name": "Naam",
    "zdf_videovoting_editor.open_preview": "Open voorbeeld (debug)",
    "zdf_videovoting_editor.options": "Opties",
    "zdf_videovoting_editor.prefill_data": "Vul gegevens vooraf in van bestaande stemming",
    "zdf_videovoting_editor.question_name": "Vraagnaam",
    "zdf_videovoting_editor.question_type": "Vraagtype",
    "zdf_videovoting_editor.questions": "Vragen:",
    "zdf_videovoting_editor.remove_chapter": "Verwijder hoofdstuk",
    "zdf_videovoting_editor.selected_chapter": "Geselecteerd hoofdstuk:",
    "zdf_videovoting_editor.selected_space": "Geselecteerde ruimte:",
    "zdf_videovoting_editor.slider_answers": "Schuifantwoorden",
    "zdf_videovoting_editor.slider_options": "Schuifopties",
    "zdf_videovoting_editor.stops_video": "Stopt video",
    "zdf_videovoting_editor.timestamp": "Tijdstempel",
    "zdf_videovoting_editor.unit": "Eenheid",
    "zdf_videovoting_editor.video_info": "Video-info:",
    "zdf_videovoting_editor.voting_title": "Stem titel",
    "{count} {noun}": "{count} {noun}"
}
